import { defineStore } from 'pinia';
import { ref } from 'vue';
import clientsAPI from '@/api/clients';
import type { Client } from '@/types/Client';
import type { ClientLead } from '@/types/ClientLead';

export const useClientsStore = defineStore('clients', () => {
  const clients = ref<Client[]>([]);
  const clients_leads = ref<ClientLead[]>([]);
  const clients_result = ref<Client[]>([]);
  
  const fetchClients = async (params: any): Promise<{ data: Client[]; total: number }> => {
    try {
      
      const response = await clientsAPI.getClients(params);
      const data: Client[] = response.data.data;
      const total = response.data.meta.total;
      clients.value = data;
      return { data, total };
    } catch (error) {
      console.error('Error fetching client s:', error);
      throw error;
    }
  };

  const fetchClientById = async (id: number) => {
    try {
      const response = await clientsAPI.getClientById(id);
      return response.data.data as Client;
    } catch (error) {
      console.error(`Error fetching client  with ID ${id}:`, error);
    }
  };

  const createClient = async (clientData: Partial<Client>) => {
    try {
      const response = await clientsAPI.createClient(clientData);
      clients.value.push(response.data.data as Client);
      return response.data;
    } catch (error) {
      console.error('Error creating client :', error);
    }
  };

  const updateClient = async (id: number, clientData: Partial<Client>) => {
    try {
      const response = await clientsAPI.updateClient(id, clientData);
      const updated = response.data.data as Client;
      const index = clients.value.findIndex((c) => c.id === id);
      if (index !== -1) {
        clients.value[index] = updated;
      }
      return response.data;
    } catch (error) {
      console.error(`Error updating client  with ID ${id}:`, error);
      throw error;
    }
  };

  const deleteClient = async (id: number) => {
    try {
      await clientsAPI.deleteClient(id);
      clients.value = clients.value.filter((c) => c.id !== id);
    } catch (error) {
      console.error(`Error deleting client  with ID ${id}:`, error);
    }
  };

  const searchClientsAndLeads = async (params: any): Promise<{ data: Client[]}> => {
    try {
      const response = await clientsAPI.searchClientsAndLeads(params);
      const data: ClientLead[] = response.data;
      clients_leads.value = data
      return { data };
    } catch (error) {
      console.error('Error fetching client s:', error);
      throw error;
    }
  };
  const searchClients = async (params: any): Promise<{ data: Client[]}> => {
    try {
      const response = await clientsAPI.getClients(params);
      const data: Client[] = response.data.data;
      clients_result.value = data
      return { data };
    } catch (error) {
      console.error('Error fetching client s:', error);
      throw error;
    }
  };

  return {
    clients,
    clients_leads,
    clients_result,
    fetchClients,
    fetchClientById,
    createClient,
    updateClient,
    deleteClient,
    searchClientsAndLeads,
    searchClients
  };
});
